var cov_1q2yxgswzh = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Slider/utils.ts",
      hash = "c2aba0aae916d7e72070149dc2eb88c61d07aad8",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Slider/utils.ts",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 16
        },
        end: {
          line: 4,
          column: 32
        }
      },
      "1": {
        start: {
          line: 5,
          column: 11
        },
        end: {
          line: 5,
          column: 12
        }
      },
      "2": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 8,
          column: 4
        }
      },
      "3": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 25
        }
      },
      "4": {
        start: {
          line: 7,
          column: 19
        },
        end: {
          line: 7,
          column: 25
        }
      },
      "5": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 11,
          column: 27
        }
      },
      "6": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 11,
          column: 27
        }
      },
      "7": {
        start: {
          line: 13,
          column: 14
        },
        end: {
          line: 13,
          column: 23
        }
      },
      "8": {
        start: {
          line: 14,
          column: 14
        },
        end: {
          line: 14,
          column: 27
        }
      },
      "9": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 51
        }
      },
      "10": {
        start: {
          line: 20,
          column: 16
        },
        end: {
          line: 20,
          column: 32
        }
      },
      "11": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 55
        }
      },
      "12": {
        start: {
          line: 22,
          column: 18
        },
        end: {
          line: 22,
          column: 55
        }
      },
      "13": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 24,
          column: 35
        }
      },
      "14": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 24,
          column: 35
        }
      },
      "15": {
        start: {
          line: 25,
          column: 13
        },
        end: {
          line: 25,
          column: 36
        }
      },
      "16": {
        start: {
          line: 26,
          column: 14
        },
        end: {
          line: 26,
          column: 23
        }
      },
      "17": {
        start: {
          line: 27,
          column: 14
        },
        end: {
          line: 27,
          column: 27
        }
      },
      "18": {
        start: {
          line: 28,
          column: 16
        },
        end: {
          line: 28,
          column: 34
        }
      },
      "19": {
        start: {
          line: 29,
          column: 15
        },
        end: {
          line: 29,
          column: 41
        }
      },
      "20": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 59
        }
      }
    },
    fnMap: {
      "0": {
        name: "value2per",
        decl: {
          start: {
            line: 3,
            column: 16
          },
          end: {
            line: 3,
            column: 25
          }
        },
        loc: {
          start: {
            line: 3,
            column: 58
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 6,
            column: 17
          }
        },
        loc: {
          start: {
            line: 6,
            column: 26
          },
          end: {
            line: 8,
            column: 3
          }
        },
        line: 6
      },
      "2": {
        name: "per2value",
        decl: {
          start: {
            line: 19,
            column: 16
          },
          end: {
            line: 19,
            column: 25
          }
        },
        loc: {
          start: {
            line: 19,
            column: 66
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 25
          }
        }, {
          start: {
            line: 7,
            column: 4
          },
          end: {
            line: 7,
            column: 25
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 27
          }
        }, {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 11,
            column: 27
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 19,
            column: 56
          },
          end: {
            line: 19,
            column: 64
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 19,
            column: 63
          },
          end: {
            line: 19,
            column: 64
          }
        }],
        line: 19
      },
      "3": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 55
          }
        }, {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 55
          }
        }],
        line: 22
      },
      "4": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 35
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 35
          }
        }, {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 35
          }
        }],
        line: 24
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { toPrecision } from '../utils/numbers';
export function value2per(value, scale) {
  cov_1q2yxgswzh.f[0]++;
  var range = (cov_1q2yxgswzh.s[0]++, scale.length - 1);
  var ps = (cov_1q2yxgswzh.s[1]++, 0);
  cov_1q2yxgswzh.s[2]++;
  scale.forEach(function (s, i) {
    cov_1q2yxgswzh.f[1]++;
    cov_1q2yxgswzh.s[3]++;

    if (value > s) {
      cov_1q2yxgswzh.b[0][0]++;
      cov_1q2yxgswzh.s[4]++;
      ps = i;
    } else {
      cov_1q2yxgswzh.b[0][1]++;
    }
  }); // end

  cov_1q2yxgswzh.s[5]++;

  if (ps >= range) {
    cov_1q2yxgswzh.b[1][0]++;
    cov_1q2yxgswzh.s[6]++;
    return 1;
  } else {
    cov_1q2yxgswzh.b[1][1]++;
  }

  var min = (cov_1q2yxgswzh.s[7]++, scale[ps]);
  var max = (cov_1q2yxgswzh.s[8]++, scale[ps + 1]);
  cov_1q2yxgswzh.s[9]++;
  return (ps + (value - min) / (max - min)) / range;
}
export function per2value(per, scale) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1q2yxgswzh.b[2][0]++, 1);
  cov_1q2yxgswzh.f[2]++;
  var range = (cov_1q2yxgswzh.s[10]++, scale.length - 1);
  cov_1q2yxgswzh.s[11]++;

  if (step === 0) {
    cov_1q2yxgswzh.b[3][0]++;
    cov_1q2yxgswzh.s[12]++;
    return scale[Math.round(per * range)];
  } else {
    cov_1q2yxgswzh.b[3][1]++;
  }

  cov_1q2yxgswzh.s[13]++;

  if (per >= 1) {
    cov_1q2yxgswzh.b[4][0]++;
    cov_1q2yxgswzh.s[14]++;
    return scale[range];
  } else {
    cov_1q2yxgswzh.b[4][1]++;
  }

  var ps = (cov_1q2yxgswzh.s[15]++, Math.floor(per * range));
  var min = (cov_1q2yxgswzh.s[16]++, scale[ps]);
  var max = (cov_1q2yxgswzh.s[17]++, scale[ps + 1]);
  var count = (cov_1q2yxgswzh.s[18]++, (max - min) / step);
  var sper = (cov_1q2yxgswzh.s[19]++, (per - ps / range) * range);
  cov_1q2yxgswzh.s[20]++;
  return toPrecision(min + Math.round(sper * count) * step);
}